(() => {
  const getSection = (key, fallbackSelector) => {
    return document.querySelector(`[id*="__${key}"]`) ||
      document.querySelector(`[id$="${key}"]`) ||
      document.querySelector(fallbackSelector)?.closest('.shopify-section');
  };

  const applyHomepageOrder = () => {
    const quick = getSection('bnv2_quick', '.bnv2-product-grid--six');
    const drop = getSection('bnv2_drop', '[data-bn-drop-live]');

    if (quick) {
      const title = quick.querySelector('.bnv2-title');
      if (title && title.textContent.trim() !== 'BESTSELLERY') {
        title.textContent = 'BESTSELLERY';
      }
    }

    if (quick && drop && quick.nextElementSibling !== drop) {
      quick.insertAdjacentElement('afterend', drop);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHomepageOrder, { once: true });
  } else {
    applyHomepageOrder();
  }

  document.addEventListener('shopify:section:load', applyHomepageOrder);
  document.addEventListener('shopify:section:reorder', applyHomepageOrder);

  const observer = new MutationObserver(() => window.requestAnimationFrame(applyHomepageOrder));
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);
})();
